/**
 * Helper de classes Tailwind pour les inputs texte des pages auth.
 * Source unique de vérité, évite la dérive palette/focus ring entre pages.
 * `PasswordInput` a son propre styling et n'utilise PAS ce helper.
 */
export function inputClasses(hasError: boolean): string {
  return [
    "block h-12 w-full rounded-xl border bg-white px-4 text-base text-champagne-900",
    "placeholder:text-champagne-800/30 focus:outline-none focus:ring-2",
    hasError
      ? "border-red-600 focus:border-red-700 focus:ring-red-600/20"
      : "border-champagne-800/20 focus:border-champagne-500 focus:ring-champagne-500/20",
  ].join(" ");
}
